/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';

import LowerFeedHeader from './LowerFeedHeader';
import Search from './Search';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import TV from '../../../../shared/images/TV.svg';
import HeaderText from '../../../../shared/_TBComponents/HeaderText';

import {
  setActiveReduxModal,
  setIsFeedShowing,
  setIsTvMode,
  setSearchString,
} from '../../ducks/feedActions';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import { feedTracker } from '../../../../shared/utils/amplitudeHelper';

const FeedHeaderDiv = styled('div')`
  position: sticky;
  top: 49px;
  padding: 15px 15px 0 15px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  width: 630px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  @media screen and (max-width: 640px) {
    width: 100%;
    max-width: 100%;
    min-width: 380px;
    padding-left: 0;
    padding-right: 0;
  }
`;

const FeedToggleText = styled('div')`
  font-family: 'Nunito Sans', sans-serif;
  align-self: center;
  margin-left: 10px;
  height: 20px;
  border: 0px;
  cursor: pointer;
  font-weight: 600;
  line-height: 20px;
  color: #444444;
`;

const FilterIconContainer = styled('div')`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 4px 8px 0 rgba(48, 49, 51, 0.05);
  height: 42px;
  width: 42px;
  background-color: #ffffff;
  transition: ${TransitionGlobal};

  :hover {
    opacity: 0.7;
  }
`;

const HeaderActionsContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const IconBadgeWrapper = styled('div')`
  width: 42px;
  height: 42px;
  margin-right: 10px;
`;

const SelectedGroupsCount = styled('div')`
  height: 13px;
  width: 13px;
  border-radius: 50%;
  background-color: #616161;
  color: #ffffff;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -40px;
  right: -32px;
`;

const TVIconContainer = styled('div')`
  height: 20px;
  width: 20px;
  background-color: #ffffff;
  background-image: url(${TV});
  background-repeat: no-repeat;
  background-size: 20px;
  margin-top: -2px;
`;

const TvToggleContainer = styled('div')`
  margin-right: 10px;
  border-radius: 500px;
  border: 0 !important;
  box-shadow: 0 4px 8px 0 rgba(48, 49, 51, 0.05);
  height: 42px;
  width: 128px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  cursor: pointer;
  transition: ${TransitionGlobal};

  :hover {
    opacity: 0.7;
  }

  @media screen and (max-width: 932px) {
    display: none;
  }
`;

const UpperHeaderBox = styled('div')`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 640px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const FeedHeader = ({ scrollToTopOfFeed }) => {
  const selectedGroups = useSelector((state) => state.feed.data.selectedGroups);
  const selectedGroupsCount = selectedGroups.length;
  const hasSelectedGroups = selectedGroupsCount > 0;

  const dispatch = useDispatch();

  // switching to TV mode defaults to PR posts and eliminates search parameter
  const handleTvModeClick = () => {
    batch(() => {
      dispatch(setIsTvMode(true));
      dispatch(setSearchString(''));
      dispatch(setIsFeedShowing(false));
    });
    feedTracker('Normal Mode', 'Click to view TV Mode');
  };

  const handleFilterClick = () => {
    dispatch(setActiveReduxModal('filter-groups-modal'));
    feedTracker('Normal Mode', 'Group filter modal opened');
  };

  return (
    <FeedHeaderDiv>
      <UpperHeaderBox>
        <HeaderText fontWeight='300' letterSpacing='normal'>
          Team Feed
        </HeaderText>
        <HeaderActionsContainer>
          <TvToggleContainer onClick={handleTvModeClick} aria-label='Switch to TV mode'>
            <TVIconContainer />
            <FeedToggleText>TV Mode</FeedToggleText>
          </TvToggleContainer>
          <IconBadgeWrapper>
            <FilterIconContainer onClick={handleFilterClick} aria-label='Filter by groups'>
              <IcomoonReact
                iconSet={iconSet}
                size={hasSelectedGroups ? 28 : 30}
                icon='group'
                color='#444444'
              />
            </FilterIconContainer>
            {hasSelectedGroups && (
              <SelectedGroupsCount aria-label={`${selectedGroupsCount} groups selected`}>{selectedGroupsCount}</SelectedGroupsCount>
            )}
          </IconBadgeWrapper>
          <Search isClearable />
        </HeaderActionsContainer>
      </UpperHeaderBox>
      <LowerFeedHeader scrollToTopOfFeed={scrollToTopOfFeed} />
    </FeedHeaderDiv>
  );
};

FeedHeader.propTypes = {
  scrollToTopOfFeed: PropTypes.func.isRequired,
};

export default FeedHeader;
